(function ($, Drupal) {
    Drupal.behaviors.applydualAnchors = {
        attach: function(context, settings) {
            var hash = window.location.hash;
            if ( hash === "#usage-alerts") {
                $(".accordion", context).foundation("toggle", $("#bill-alerts"));
            }
        }
    }
})(jQuery, Drupal);  